export * from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebarSubItem.vue?vue&type=template&id=745bc5ca&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/sidebarSubItem.vue?vue&type=template&id=745bc5ca&
// module id = 332
// module chunks = 30